/* 
  Class to import and hold all the mana symbols,
  easier to pull them in from other places.
*/

import white from "../assets/costs/W.svg";
import blue from "../assets/costs/U.svg";
import black from "../assets/costs/B.svg";
import red from "../assets/costs/R.svg";
import green from "../assets/costs/G.svg";
import colourless from "../assets/costs/C.svg";
import x from "../assets/costs/X.svg";
import zero from "../assets/costs/0.svg";
import one from "../assets/costs/1.svg";
import two from "../assets/costs/2.svg";
import three from "../assets/costs/3.svg";
import four from "../assets/costs/4.svg";
import five from "../assets/costs/5.svg";
import six from "../assets/costs/6.svg";
import seven from "../assets/costs/7.svg";
import eight from "../assets/costs/8.svg";
import nine from "../assets/costs/9.svg";
import tap from "../assets/costs/T.svg";
import BG from "../assets/costs/BG.svg";
import BR from "../assets/costs/BR.svg";
import GU from "../assets/costs/GU.svg";
import GW from "../assets/costs/GW.svg";
import RG from "../assets/costs/RG.svg";
import RW from "../assets/costs/RW.svg";
import UB from "../assets/costs/UB.svg";
import UR from "../assets/costs/UR.svg";
import WB from "../assets/costs/WB.svg";
import WU from "../assets/costs/WU.svg";
import E from "../assets/costs/Energy.svg"
import WP from "../assets/costs/WP.svg"
import UP from "../assets/costs/UP.svg"
import BP from "../assets/costs/BP.svg"
import RP from "../assets/costs/RP.svg"
import GP from "../assets/costs/GP.svg"
import CW from "../assets/costs/CW.svg"
import CU from "../assets/costs/CU.svg"
import CB from "../assets/costs/CB.svg"
import CR from "../assets/costs/CR.svg"
import CG from "../assets/costs/CG.svg"
import TWOW from "../assets/costs/2W.svg"
import TWOU from "../assets/costs/2U.svg"
import TWOB from "../assets/costs/2B.svg"
import TWOR from "../assets/costs/2R.svg"
import TWOG from "../assets/costs/2G.svg"
import GUP from "../assets/costs/GUP.svg"
import GWP from "../assets/costs/GWP.svg"
import S from "../assets/costs/S.svg"

// TODO add phyrexian 

const COSTS = {
  "{W}": white,
  "{U}": blue,
  "{B}": black,
  "{R}": red,
  "{G}": green,
  "{C}": colourless,
  "{X}": x,
  "{0}": zero,
  "{1}": one,
  "{2}": two,
  "{3}": three,
  "{4}": four,
  "{5}": five,
  "{6}": six,
  "{7}": seven,
  "{8}": eight,
  "{9}": nine,
  "{T}": tap,
	"{B/G}" : BG,
	"{B/R}" : BR,
	"{G/U}" : GU,
	"{G/W}" : GW,
	"{R/G}" : RG,
	"{R/W}" : RW,
	"{U/B}" : UB,
	"{U/R}" : UR,
	"{W/B}" : WB,
	"{W/U}" : WU,
	"{E}" : E,
	"{W/P}" : WP,
	"{U/P}" : UP,
	"{B/P}" : BP,
	"{R/P}" : RP,
	"{G/P}" : GP,
	"{C/W}" : CW,
	"{C/U}" : CU,
	"{C/B}" : CB,
	"{C/R}" : CR,
	"{C/G}" : CG,
	"{2/W}" : TWOW,
	"{2/U}" : TWOU,
	"{2/B}" : TWOB,
	"{2/R}" : TWOR,
	"{2/G}" : TWOG,
	"{G/U/P}" : GUP,
	"{G/W/P}" : GWP,
	"{S}" : S

};

export default COSTS;
